import React from "react";

// Floating "Book a Test Drive" button with vibrant gradient, rounded shape, and vertical bounce animation
// Clicking the button scrolls to the contact section of the page.
const TestDriveButton = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <button
      onClick={scrollToContact}
      className="fixed right-5 bottom-5 z-50 animate-bounce bg-yellow-500 hover:bg-yellow-400 text-blue-950 font-extrabold py-2 px-5 rounded-xl shadow-md hover:shadow-yellow-500/20 transition transform hover:scale-105"
      aria-label="Book a test drive"
    >
      Book a Test Drive
    </button>
  );
};

export default TestDriveButton;
